<template>
  <div
    :class="style.expanderHeaderIcons"
    data-sb-regression="sb-row-expansion-header"
  >
    <img
      :src="PlusIcon"
      :alt="$t('sbTable.expandAllRows')"
      :class="{
        [style.expanderIcon]: true,
      }"
      data-sb-automation="row-all-expand"
      @click="expandAll"
    >
    <img
      :src="MinusIcon"
      :alt="$t('sbTable.collapseAllRows')"
      data-sb-automation="row-all-collapse"
      :class="style.expanderIcon"
      @click="collapseAll"
    >
  </div>
</template>

<script setup>
import style from '@src/components/Table/next/components/style/rowExpansion.module.scss';
import PlusIcon from '@public/media/icons/plus.svg';
import MinusIcon from '@public/media/icons/minus.svg';

// eslint-disable-next-line no-undef
const emit = defineEmits([
  /**
   * Event emitted when the user clicks the expand all button.
   */
  'expand-all',
  /**
   * Event emitted when the user clicks the collapse all button.
   */
  'collapse-all',
]);

const expandAll = () => emit('expand-all');
const collapseAll = () => emit('collapse-all');
</script>
